import gql from 'graphql-tag';

export default gql`
  fragment prospectPoolTotalScoreRankHistoryFragment on ProspectPoolTotalScoreRankHistory {
    id
    createdDate
    fromRank
    toRank
    fromScore
    toScore
    createdAt
    updatedAt
  }
`;
